import Link from '../../views/EmailValidation';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  error: state.shift.status.error
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickLoginHandler: value => {
      //console.log(value);
      dispatch(push(`/${locale}/login`));
    },

    emailValidation: email => dispatch(actions.emailValidation(email))
  };
};

const EmailValidationComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default EmailValidationComponent;



// WEBPACK FOOTER //
// ./src/components/container/EmailValidation/index.js